import { ReactElement } from "react";
import { UiLOneColumn } from "@rotorstudios/fe-ui";

import { UiDynamicRenderer } from "../../_common/modules/fe-ui/UiDynamicRenderer";
import useGallery from "./useGallery";

import "./_Gallery.scss";

const Gallery = (): ReactElement => {
  const { mainContent } = useGallery();

  const getMainContent = () => <UiDynamicRenderer data={mainContent} />;

  return (
    <div className="Gallery">
      <UiLOneColumn mainContent={getMainContent()} />
    </div>
  );
};

export default Gallery;
